module.exports = __webpack_public_path__ + "static/sectwo-916c0729f2303eee4f07505440483f36.svg";